import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import OverviewSection from '../Components/lab/OverviewSection'
import OfferingSection from '../Components/lab/OfferingSection'
import ClientSection from '../Components/lab/ClientSection'
import ResearchSection from '../Components/lab/ResearchSection'
import InnovationAchievements from '../Components/lab/InnovationAchievements'
import ProductsSlider from '../Components/lab/ProductsSlider'
import IndustryFirstsSlider from '../Components/lab/IndustryFirstsSlider'
import IndiaStorySection from '../Components/lab/IndiaStorySection'
import InnovationAwardsSection from '../Components/lab/InnovationAwardsSection'
import ThoughtSection from '../Components/lab/ThoughtSection'
import LeadingWaySection from '../Components/lab/LeadingWaySection'
import { Helmet } from "react-helmet-async";

function Lab() {
    return (
        <div>
            <Helmet>
    <title>
        Makers Lab | Innovation, Research & Technology | Mobikode
    </title>

    <meta
        name="description"
        content="Explore Mobikode Makers Lab, where research, innovation, emerging technologies, and product development come together to create practical digital solutions for businesses."
    />

    <meta
        name="keywords"
        content="Mobikode Makers Lab, Makers Lab, Technology Innovation, Technology Research, Digital Innovation, Product Innovation, Emerging Technologies, Technology Solutions, R&D Lab, Software Innovation, Enterprise AI & ServiceNow Consulting, Technology Research Lab, Mobikode Innovation"
    />

    <link
        rel="canonical"
        href="https://www.mobikode.com/makers-lab"
    />

    <meta
        property="og:title"
        content="Makers Lab | Innovation, Research & Technology | Mobikode"
    />

    <meta
        property="og:description"
        content="Discover Mobikode Makers Lab and explore our work in research, innovation, emerging technologies, product development, and Enterprise AI & ServiceNow Consulting."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/makers-lab"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/lab/bg1.png"
    />

    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="Makers Lab | Innovation, Research & Technology | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Explore Mobikode Makers Lab, focused on technology research, innovation, emerging technologies, product development, and practical digital solutions."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/lab/bg1.png"
    />
</Helmet>
            <WhoHero
                title="Makers Lab"
                text="Technology. Transformation. Trust."
                imgData="/assets/lab/bg1.png"
            />
            <OverviewSection />
            <OfferingSection />
            <ClientSection />
            <ResearchSection />
            <InnovationAchievements />
            {/* <ProductsSlider /> */}
            <IndustryFirstsSlider />
            <IndiaStorySection />
            <InnovationAwardsSection />
            <LeadingWaySection />
            <ThoughtSection />
        </div>
    )
}

export default Lab
